/* eslint-disable no-return-assign */
import { Alert, AlertIcon, Badge, Button, Flex, Link, Menu, MenuButton } from '@chakra-ui/react'
import { BsCalendarCheck } from 'react-icons/bs'
import { FaBell, FaBook, FaBrain, FaBriefcase, FaBullhorn, FaChalkboardTeacher, FaChevronDown, FaClipboardList, FaCog, FaColumns, FaCopy, FaDoorOpen, FaExchangeAlt, FaFilePdf, FaFileSignature, FaHeadset, FaHome, FaIdCard, FaMoneyBill, FaPaperPlane, FaPeopleArrows, FaPlane, FaPlusSquare, FaQuestionCircle, FaSitemap, FaStream, FaStreetView, FaTachometerAlt, FaUserClock, FaUsers, FaUsersCog, FaVideo } from 'react-icons/fa'
import { MdLogout, MdMenu, MdPassword } from 'react-icons/md'
import { useLocation, useNavigate } from 'react-router-dom'
import { iEmpresaMultiAcesso, useAuth } from '../../contexts/AuthContext'
import { ModalSelecaoEmpresa } from './Components/ModalSelecaoEmpresa'
import { StyledMenuItem } from './Components/StyledMenuItem'
import { Container, FlexIcon, LogoContainer } from './styles'

import { useEffect, useState } from 'react'
import { AiOutlineTable } from 'react-icons/ai'
import { GoGraph } from 'react-icons/go'
import { iConfigPDI, iNineBoxConfig } from '../../pages/Usuario/Empresa/Configuracao'
import { usePermissaoLog } from '../../pages/Auditoria/permissao'
import { appApi, urlSigah } from '../../services/appApi'
import { parseJwt } from '../../services/token'
import { AutorizarAHPI, AutorizarPI, AutorizarRelatorioClientes, ObterToken, PropInvalida } from '../../Utils/Helper'
import { StyledMenuButton } from './Components/StyledMenuButton'
import { StyledMenuList } from './Components/StyledMenuList'
const LogoFO = 'https://sigah.blob.core.windows.net/assets/front/FO.svg'
const LogoPec = 'https://sigah.blob.core.windows.net/assets/front/PEC.svg'
const LogoPulse = 'https://sigah.blob.core.windows.net/assets/front/Pulse.svg'

export interface iConfigs {
  nineBoxConfig: iNineBoxConfig
  configPDI: iConfigPDI
}

export const NavBar: React.FC = () => {
  const { Permissoes, permitirFuncao, isAuth, logOut, refreshToken, obterVersao, recarregarPermissoes, modoFree, temAlgumaPermissao, usuarioAh, ListaEmpresas } = useAuth()
  const BlackList = ['/', 'RespostaPesquisa', 'RespostaPesquisaIndicativa', 'Abertura', 'RespostaNps', 'VisualizarImersao', 'EsqueciSenha', 'Preenchimento', 'Pi', 'pi', 'responder']
  const { pathname } = useLocation()

  function getConfig(): void {
    appApi.get('Empresa/Configuracao')
      .then(res => setConfiguracaoEmpresaNineBox(res.data))
      .catch(err => console.log(err))
  }

  function NaoTemNavBar(): boolean {
    let temAcesso = true
    if (pathname === '/') { return true }
    pathname.split('/').forEach((e) => {
      const res = BlackList.find(r => r === e)
      if (res !== undefined) {
        temAcesso = false
      }
    })

    if (temAcesso) {
      return false
    }

    return true
  }

  if (NaoTemNavBar() || !isAuth()) {
    return null
  }

  function GestoresViaCerta(): boolean {
    if (parseJwt().eid !== 'faee5a9b-55ff-4270-9f18-8e3b7139dd5d') return true

    const cid = parseJwt().cid
    if (cid === '4ab4e58e-a58c-4081-ac1c-5220fdd9bff0' || cid === 'b33ffa78-cf8d-4a53-a2f2-e26e57384ef3' || cid === 'eebf2128-ce3e-47e9-b6d4-b66ad0a2ede0' || cid === '446ba5eb-ec47-4598-b788-06d45334207b' || cid === '91e8070c-aa4d-47b8-af3a-b84b8ae273d0') {
      return true
    }

    return false
  }

  const nav = useNavigate()
  const acessoCargosESalarios = parseJwt().adm === 'True' || permitirFuncao('CargosESalarios', 'Acesso')
  const acessoCargos = acessoCargosESalarios || permitirFuncao('CargosESalarios', 'cargos')
  const acessoSalarios = acessoCargosESalarios || permitirFuncao('CargosESalarios', 'salarios')
  const acessoTrilhas = acessoCargosESalarios || permitirFuncao('CargosESalarios', 'trilhas-carreira')
  const gerenciaTrilhaCarreira = Permissoes.funcionalidades?.some(e => e.tipo === 6 && e.liberado)
  const Route = `${urlSigah}/Home/ExtLogin/?token=${ObterToken()}`
  const redirectPage = (ct: string, at: string): any => window.location.href = `${Route}&ct=${ct}&at=${at}`
  const [configuracaoEmpresaNineBox, setConfiguracaoEmpresaNineBox] = useState<iConfigs>()
  const [modalEmpresasOpen, setModalEmpresasOpen] = useState(false)
  const permissaoLog = usePermissaoLog()
  const empresaSelecionadaSalva = localStorage.getItem('empresaMultiAcesso')
  const empresaSelecionada: iEmpresaMultiAcesso | undefined = empresaSelecionadaSalva ? JSON.parse(empresaSelecionadaSalva) : undefined

  function BaixarRelatorioClientes(): void {
    appApi
      .get('Empresa/RelatorioClientes', { responseType: 'blob' })
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data], { type: 'text/csv;charset=utf-8;' }))
        const link = document.createElement('a')
        link.href = url
        link.download = 'relatorio_clientes.csv'
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
      .catch(error => {
        console.error('Erro ao baixar relatório de clientes:', error)
      })
  }

  function trocarEmpresa(empresaId: string, empresa?: iEmpresaMultiAcesso): void {
    appApi.post(`Auth/MultiLogin/${empresaId}`)
      .then(res => {
        if (res.status === 200) {
          localStorage.setItem('token', res.data.token)
          localStorage.setItem('logo', res.data.logo)
          if (empresa) {
            localStorage.setItem('empresaMultiAcesso', JSON.stringify(empresa))
          } else {
            localStorage.removeItem('empresaMultiAcesso')
          }
          localStorage.removeItem('departamentosIdNineBox')
          localStorage.removeItem('squadsIdNineBox')
          localStorage.removeItem('gestoresIdNineBox')
          appApi.defaults.headers.common.Authorization = `bearer ${res.data.token as string}`
          window.location.href = '/Colaborador'
        }
      })
      .catch(err => console.log(err))
  }

  function selecionarEmpresa(empresa: iEmpresaMultiAcesso): void {
    trocarEmpresa(empresa.empresaId, empresa)
  }

  function retornarParaAh(): void {
    trocarEmpresa(parseJwt().eido)
  }

  const NineBoxravadaParaAdmin: boolean = calculaPermissao()

  function calculaPermissao(): boolean {
    if (parseJwt().adm === 'True') {
      if (configuracaoEmpresaNineBox?.nineBoxConfig?.visualizacaoRestringida) {
        if (configuracaoEmpresaNineBox.nineBoxConfig.usuariosPermitidos?.includes(parseJwt().cid)) {
          return true
        } else {
          return false
        }
      } else {
        return true
      }
    } else {
      return true
    }
  }

  useEffect(() => {
    obterVersao()
    refreshToken()
    getConfig()
    if (Permissoes.permissoes.length === 0) {
      recarregarPermissoes()
    }
  }, [pathname])
  return (<>
    <Container>
      <Flex alignItems={'center'} gap={'.5rem'}>
        <LogoContainer>
          <img onClick={() => nav('/Colaborador')} src={localStorage.getItem('logo') === 'https://sigah.arquiteturahumana.com.br/css/logoBranco.png' || PropInvalida(localStorage.getItem('logo')) ? 'https://sigah.blob.core.windows.net/onboard/f99445d7-d98d-48ad-9cdb-a443a9f636a2.png' : localStorage.getItem('logo') ?? ''} />
          <hr />
        </LogoContainer>
        <Button
          px={'.75rem'}
          height={'1.925rem'}
          borderRadius='.25rem'
          transition='all 0.2s'
          _hover={{ bg: 'var(--Rosa)' }}
          _focus={{ bg: 'var(--Rosa)' }}
          bg={'none'}
          fontWeight={'600'}
          fontSize={'.85rem'}
          _active={{ bg: 'var(--Rosa)' }}
          onClick={() => nav('/Colaborador')}
        >
          Início
        </Button>

        {AutorizarPI() && (AutorizarAHPI() || parseJwt().adm === 'True' || parseJwt().consultoria === 'True' || permitirFuncao('Organograma', 'visao-geral') || permitirFuncao('Organograma', 'areas')) &&
          <Menu>
            <StyledMenuButton rightIcon={<FaChevronDown style={{ marginLeft: '-4px' }} size={10}/>}>
              Assessment PI &reg;
            </StyledMenuButton>
            <StyledMenuList>
              {
                (AutorizarAHPI() || parseJwt().adm === 'True' || parseJwt().consultoria === 'True' || permitirFuncao('Organograma', 'visao-geral')) && (
                  <StyledMenuItem
                    onClick={() => nav('/AssessmentPi/Dashboard')}
                  >
                    <FaColumns style={{ marginRight: '.4rem' }} />
                    Dashboard
                  </StyledMenuItem>
                )
              }
              {
                (AutorizarAHPI() || parseJwt().adm === 'True' || parseJwt().consultoria === 'True' || permitirFuncao('Organograma', 'visao-geral')) && (
                  <StyledMenuItem
                    onClick={() => nav('/AssessmentPi/Dashboard2')}
                  >
                    <FaColumns style={{ marginRight: '.4rem' }} />
                    Dashboard job target
                  </StyledMenuItem>
                )
              }

              {
                (AutorizarAHPI() || parseJwt().adm === 'True' || parseJwt().consultoria === 'False' || permitirFuncao('Organograma', 'areas')) && (
                  <StyledMenuItem
                    onClick={() => nav('/AssessmentPi/JobTarget/Create')}
                  >
                    <FaIdCard style={{ marginRight: '.4rem' }} />
                    Novo job target
                  </StyledMenuItem>
                )
              }
               <StyledMenuItem onClick={() => nav('/Tutoriais/AssessmentPI')}>
                <FaVideo style={{ marginRight: '.4rem' }} />
                Conheça o módulo Assessment PI &reg;
              </StyledMenuItem>
            </StyledMenuList>
          </Menu>
        }

        {!AutorizarPI() && parseJwt().adm === 'True' &&
          <Menu>
            <StyledMenuButton rightIcon={<FaChevronDown style={{ marginLeft: '-4px' }} size={10}/>}>
              Assessment PI &reg;
            </StyledMenuButton>
            <StyledMenuList>
              <StyledMenuItem>
                <FaColumns style={{ marginRight: '.4rem' }} />
                Módulo bloqueado
              </StyledMenuItem>

              <StyledMenuItem disabled>
                <FaColumns style={{ marginRight: '.4rem' }} />
                Dashboard
              </StyledMenuItem>

              <StyledMenuItem disabled>
                <FaIdCard style={{ marginRight: '.4rem' }} />
                Novo job target
              </StyledMenuItem>

              <StyledMenuItem onClick={() => nav('/Tutoriais/AssessmentPI')}>
                <FaVideo style={{ marginRight: '.4rem' }} />
                Conheça o módulo Assessment PI &reg;
              </StyledMenuItem>

            </StyledMenuList>
          </Menu>
        }

        {(AutorizarPI() || Permissoes.prismah) && (AutorizarAHPI() || parseJwt().adm === 'True' || permitirFuncao('PRISMAH', 'dashboard') || permitirFuncao('PRISMAH', 'novo-relatorio')) &&
          <Menu>
            <StyledMenuButton rightIcon={<FaChevronDown style={{ marginLeft: '-4px' }} size={10}/>}>
              PRISMAH
            </StyledMenuButton>
            <StyledMenuList>
              {
                (AutorizarAHPI() || parseJwt().adm === 'True' || permitirFuncao('PRISMAH', 'dashboard')) && (
                  <StyledMenuItem
                    onClick={() => nav('/PRISMAH/Dashboard')}
                  >
                    <FaTachometerAlt style={{ marginRight: '.4rem' }} />
                    Dashboard
                  </StyledMenuItem>
                )
              }

              {
                (AutorizarAHPI()) && (
                  <StyledMenuItem
                    onClick={() => nav('/PRISMAH/Dashboard/ia')}
                  >
                    <FaBrain style={{ marginRight: '.4rem' }} />
                    Dashboard IA
                  </StyledMenuItem>
                )
              }

              {
                (AutorizarAHPI() || parseJwt().adm === 'True' || permitirFuncao('PRISMAH', 'novo-relatorio')) && (
                  <StyledMenuItem
                    onClick={() => nav('/PRISMAH/Send')}
                  >
                    <FaFilePdf style={{ marginRight: '.4rem' }} />
                    Novo relatório PRISMAH
                  </StyledMenuItem>
                )
              }
<StyledMenuItem onClick={() => nav('/Tutoriais/PRISMAH')}>
                <FaVideo style={{ marginRight: '.4rem' }} />
                Conheça o módulo PRISMAH
              </StyledMenuItem>
            </StyledMenuList>
          </Menu>
        }

        {!AutorizarPI() && !Permissoes.prismah && parseJwt().adm === 'True' &&
          <Menu>
            <StyledMenuButton rightIcon={<FaChevronDown style={{ marginLeft: '-4px' }} size={10}/>}>
              PRISMAH
            </StyledMenuButton>
            <StyledMenuList>
              <StyledMenuItem>
                <FaColumns style={{ marginRight: '.4rem' }} />
                Módulo bloqueado
              </StyledMenuItem>
              <StyledMenuItem disabled>
                <FaTachometerAlt style={{ marginRight: '.4rem' }} />
                Dashboard
              </StyledMenuItem>
              <StyledMenuItem disabled>
                <FaFilePdf />
                Novo relatório PRISMAH
              </StyledMenuItem>
  <StyledMenuItem onClick={() => nav('/Tutoriais/PRISMAH')}>
                <FaVideo style={{ marginRight: '.4rem' }} />
                Conheça o módulo PRISMAH
              </StyledMenuItem>
            </StyledMenuList>
          </Menu>
        }

        {
          (Permissoes.jornada && temAlgumaPermissao('Jornada')) && (
            <Menu>
              <StyledMenuButton rightIcon={<FaChevronDown style={{ marginLeft: '-4px' }} size={10}/>}>
                Jornada
              </StyledMenuButton>
              <StyledMenuList>
                {
                  ((parseJwt().adm === 'True') || permitirFuncao('Jornada', 'dash')) && (
                    <StyledMenuItem
                      onClick={() => nav('/Jornada/Dashboard')}
                    >
                      <FaColumns style={{ marginRight: '.4rem' }} />
                      Dashboard
                    </StyledMenuItem>
                  )
                }

                {(parseJwt().adm === 'True' || permitirFuncao('Jornada', 'trilha-onboard')) && (
                  <StyledMenuItem
                    onClick={() => nav('Jornada/Onboard?tipo=0')}
                  >
                    <FaUserClock style={{ marginRight: '.4rem' }} />
                    Trilha onboarding
                  </StyledMenuItem>
                )}

                {(parseJwt().adm === 'True' || permitirFuncao('Jornada', 'trilha-desenvolvimento')) && (
                  <StyledMenuItem
                    onClick={() => nav('Jornada/Onboard?tipo=1')}
                  >
                    <FaPlane style={{ marginRight: '.4rem' }} />
                    Trilha de desenvolvimento
                  </StyledMenuItem>
                )}

                {(parseJwt().adm === 'True' || permitirFuncao('Jornada', 'trilha-offboard')) && (
                  <StyledMenuItem
                    onClick={() => nav('Jornada/Onboard?tipo=3')}
                  >
                    <FaDoorOpen style={{ marginRight: '.4rem' }} />
                    Offboarding
                  </StyledMenuItem>
                )}

                {(parseJwt().adm === 'True' || permitirFuncao('Jornada', 'feedback-sah')) && (
                    <StyledMenuItem
                      onClick={() => nav('/Feedback')}
                    >
                      <FaCopy style={{ marginRight: '.4rem' }} />
                      Feedback
                    </StyledMenuItem>
                )}

                {
                  (parseJwt().adm === 'True' || permitirFuncao('Jornada', 'nova-reuniao-one')) && (
                    <StyledMenuItem
                      onClick={() => nav('Jornada/NovaReuniaoOne/Dashboard/Individual')}
                    >
                      <FaPeopleArrows style={{ marginRight: '.4rem' }} />
                      Reunião 1:1
                    </StyledMenuItem>
                  )
                }

                {
                  ((parseJwt().adm === 'True' || permitirFuncao('Jornada', '1on1')) && process.env.REACT_APP_VIACERTA_EMPRESA_ID === parseJwt().eid) && (
                    <StyledMenuItem
                      onClick={() => nav('Jornada/ReuniaoOne')}
                    >
                      <FaPeopleArrows style={{ marginRight: '.4rem' }} />
                      Reunião 1:1 (Obsoleto)
                    </StyledMenuItem>
                  )
                }

                {
                  (parseJwt().adm === 'True' || permitirFuncao('Jornada', 'pesquisa-percepcao')) && (
                    <StyledMenuItem
                      onClick={() => nav('Jornada/Percepcao/Gestao')}
                    >
                      <FaStreetView style={{ marginRight: '.4rem' }} />
                      Pesquisa de percepção
                    </StyledMenuItem>
                  )
                }

                {
                  (parseJwt().adm === 'True' || permitirFuncao('Jornada', 'pesquisa-interna')) && (
                    <StyledMenuItem
                      onClick={() => nav('/Jornada/PesquisaInterna/Gestao')}
                    >
                      <FaClipboardList style={{ marginRight: '.4rem' }} />
                      Pesquisa interna
                    </StyledMenuItem>
                  )
                }

                {
                  (parseJwt().adm === 'True' || permitirFuncao('Jornada', 'imersão-cultural')) && (
                    <StyledMenuItem
                      onClick={() => nav('/Jornada/Imersao')}
                    >
                      <FaChalkboardTeacher style={{ marginRight: '.4rem' }} />
                      Imersão cultural
                    </StyledMenuItem>
                  )
                }

                {
                  (parseJwt().adm === 'True' || permitirFuncao('Jornada', 'enps')) && (
                    <StyledMenuItem
                      onClick={() => nav('/Jornada/eNps')}
                    >
                      <FaTachometerAlt style={{ marginRight: '.4rem' }} />
                      eNPS
                    </StyledMenuItem>
                  )
                }
                <StyledMenuItem onClick={() => nav('/Tutoriais/Jornada')}>
                <FaVideo style={{ marginRight: '.4rem' }} />
                Conheça o módulo Jornada
              </StyledMenuItem>

                {/* {
                                    (parseJwt().adm === 'True' || permitirFuncao('Jornada', 'turnover')) && (
                                        <StyledMenuItem
                                            onClick={() => nav('/Jornada/TurnOver')}
                                        >
                                            <img src={LogoTurnOver} style={{ marginRight: '.4rem', height: '1rem' }} />
                                            Turnover
                                        </StyledMenuItem>
                                    )
                                } */}

              </StyledMenuList>
            </Menu>
          )
        }

        {
          (!Permissoes.jornada) && (
            <Menu>
              <StyledMenuButton rightIcon={<FaChevronDown style={{ marginLeft: '-4px' }} size={10}/>}>
                Jornada
              </StyledMenuButton>
              <StyledMenuList>
                  <StyledMenuItem onClick={() => nav('/Tutoriais/Jornada')}>
                <FaVideo style={{ marginRight: '.4rem' }} />
                Conheça o módulo Jornada
              </StyledMenuItem>
                <StyledMenuItem>
                  <FaColumns style={{ marginRight: '.4rem' }} />
                  Módulo bloqueado
                </StyledMenuItem>

                <StyledMenuItem
                  disabled
                >
                  <FaColumns style={{ marginRight: '.4rem' }} />
                  Dashboard
                </StyledMenuItem>

                <StyledMenuItem
                  disabled
                >
                  <FaUserClock style={{ marginRight: '.4rem' }} />
                  Trilha onboarding
                </StyledMenuItem>

                <StyledMenuItem
                  disabled
                >
                  <FaPlane style={{ marginRight: '.4rem' }} />
                  Trilha de desenvolvimento
                </StyledMenuItem>

                <StyledMenuItem
                  disabled
                >
                  <FaDoorOpen style={{ marginRight: '.4rem' }} />
                  Offboarding
                </StyledMenuItem>

                <StyledMenuItem
                  disabled
                >
                  <FaPeopleArrows style={{ marginRight: '.4rem' }} />
                  Reunião 1:1
                </StyledMenuItem>

                <StyledMenuItem
                  disabled
                >
                  <FaStreetView style={{ marginRight: '.4rem' }} />
                  Pesquisa de percepção
                </StyledMenuItem>

                <StyledMenuItem
                  disabled
                >
                  <FaClipboardList style={{ marginRight: '.4rem' }} />
                  Pesquisa interna
                </StyledMenuItem>

                <StyledMenuItem
                  disabled
                >
                  <FaChalkboardTeacher style={{ marginRight: '.4rem' }} />
                  Imersão cultural
                </StyledMenuItem>
                <StyledMenuItem
                  disabled
                >
                  <FaTachometerAlt style={{ marginRight: '.4rem' }} />
                  eNPS
                </StyledMenuItem>
              </StyledMenuList>
            </Menu>
          )
        }

        {
          (Permissoes.desempenho && temAlgumaPermissao('Desempenho')) && (
            <Menu>
              <StyledMenuButton rightIcon={<FaChevronDown style={{ marginLeft: '-4px' }} size={10}/>}>
                Desempenho
              </StyledMenuButton>
              <StyledMenuList>
                {
                  ((parseJwt().adm === 'True') || permitirFuncao('Desempenho', 'dash')) && (
                    <StyledMenuItem
                      onClick={() => nav('/Desempenho/Dashboard')}
                    >
                      <FaColumns style={{ marginRight: '.4rem' }} />
                      Dashboard
                    </StyledMenuItem>
                  )
                }

                {
                  (parseJwt().adm === 'True') && (
                    <StyledMenuItem
                      onClick={() => nav('/Desempenho/AnaliseDesempenho/SelecionarModelo')}
                    >
                      <FaPlusSquare style={{ marginRight: '.4rem' }} />
                      Criar pesquisa de desempenho por competência
                    </StyledMenuItem>
                  )
                }

                {
                  (parseJwt().adm === 'True' || permitirFuncao('Desempenho', 'pesquisa-desempenho')) && (
                    <StyledMenuItem
                      onClick={() => nav('/Desempenho/AnaliseDesempenho/Gestao')}
                    >
                      <FaCopy style={{ marginRight: '.4rem' }} />
                      Gestão de pesquisas de desempenho por competência
                    </StyledMenuItem>
                  )
                }

                {
                  (parseJwt().adm === 'True') && (
                    <StyledMenuItem
                      onClick={() => nav('/Desempenho/Formularios/Gestao')}
                    >
                      <FaClipboardList style={{ marginRight: '.4rem' }} />
                      Gestão de formulários
                    </StyledMenuItem>
                  )
                }

                {
                  (parseJwt().adm === 'True' || permitirFuncao('Desempenho', '9box')) && NineBoxravadaParaAdmin && (
                    <StyledMenuItem
                      onClick={() => nav('/Desempenho/9Box')}>
                      <AiOutlineTable style={{ marginRight: '.4rem' }} />
                      9Box
                    </StyledMenuItem>
                  )
                }

                {
                  (parseJwt().adm === 'True' || permitirFuncao('Desempenho', 'feedback-sah')) && (
                    <StyledMenuItem
                      onClick={() => nav('/Feedback')}
                    >
                      <FaCopy style={{ marginRight: '.4rem' }} />
                      Feedback
                    </StyledMenuItem>
                  )
                }

                {
                  (parseJwt().adm === 'True' || permitirFuncao('Desempenho', 'nova-reuniao-one')) && (
                    <StyledMenuItem
                      onClick={() => nav('Desempenho/NovaReuniaoOne/Dashboard/Individual')}
                    >
                      <FaPeopleArrows style={{ marginRight: '.4rem' }} />
                      Reunião 1:1
                    </StyledMenuItem>
                  )
                }

                {/* {
                  (parseJwt().adm === 'True' || permitirFuncao('Desempenho', '1on1')) && (
                    <StyledMenuItem
                      onClick={() => nav('Desempenho/ReuniaoOne')}
                    >
                      <FaPeopleArrows style={{ marginRight: '.4rem' }} />
                      Reunião 1:1
                    </StyledMenuItem>
                  )
                } */}

                {
                  (parseJwt().adm === 'True' || permitirFuncao('Desempenho', 'pdi')) && (
                    <StyledMenuItem
                      onClick={() => nav('/Desempenho/PDI/Dashboard/Individual')}
                    >
                      <BsCalendarCheck style={{ marginRight: '.4rem' }} />
                      PDI
                    </StyledMenuItem>
                  )
                }

                {
                  (parseJwt().adm === 'True' || permitirFuncao('Desempenho', 'imersao-cultural')) && (
                    <StyledMenuItem
                      onClick={() => nav('/Jornada/Imersao')}
                    >
                      <FaChalkboardTeacher style={{ marginRight: '.4rem' }} />
                      Imersão cultural
                    </StyledMenuItem>
                  )
                }

                {
                  (parseJwt().adm === 'True' || permitirFuncao('Desempenho', 'indicadores')) && (
                    <StyledMenuItem
                      onClick={() => nav('/Desempenho/Indicadores')}
                    >
                      <GoGraph style={{ marginRight: '.4rem' }} />
                      Indicadores
                    </StyledMenuItem>
                  )
                }

                {
                  // (parseJwt().adm === 'True' || permitirFuncao('Desempenho', 'indicadores')) && (
                  (parseJwt().adm === 'True' && parseJwt().eid === process.env.REACT_APP_AH_EMPRESA_ID) && (
                    <StyledMenuItem
                      onClick={() => nav('/Desempenho/Indicadores/Dashboard')}
                    >
                      <GoGraph style={{ marginRight: '.4rem' }} />
                      Dashboard de Indicadores
                    </StyledMenuItem>
                  )
                }
                <StyledMenuItem onClick={() => nav('/Tutoriais/Desempenho')}>
                <FaVideo style={{ marginRight: '.4rem' }} />
                Conheça o módulo Desempenho
              </StyledMenuItem>
              </StyledMenuList>
            </Menu>
          )
        }

        {
          (!Permissoes.desempenho) && (
            <Menu>
              <StyledMenuButton rightIcon={<FaChevronDown style={{ marginLeft: '-4px' }} size={10}/>}>
                Desempenho
              </StyledMenuButton>

              <StyledMenuList>
                <StyledMenuItem onClick={() => nav('/Tutoriais/Desempenho')}>
                <FaVideo style={{ marginRight: '.4rem' }} />
                Conheça o módulo Desempenho
              </StyledMenuItem>
                <StyledMenuItem>
                  <FaColumns style={{ marginRight: '.4rem' }} />
                  Módulo bloqueado
                </StyledMenuItem>

                <StyledMenuItem
                  disabled
                >
                  <FaColumns style={{ marginRight: '.4rem' }} />
                  Dashboard
                </StyledMenuItem>

                <StyledMenuItem
                  disabled
                >
                  <FaPlusSquare style={{ marginRight: '.4rem' }} />
                  Criar pesquisa de desempenho por competência
                </StyledMenuItem>

                <StyledMenuItem
                  disabled
                >
                  <FaCopy style={{ marginRight: '.4rem' }} />
                  Gestão de pesquisas de desempenho por competência
                </StyledMenuItem>

                <StyledMenuItem
                  disabled
                >
                  <FaClipboardList style={{ marginRight: '.4rem' }} />
                  Gestão de formulários
                </StyledMenuItem>

                <StyledMenuItem
                  disabled
                >
                  <FaPeopleArrows style={{ marginRight: '.4rem' }} />
                  Reunião 1:1
                </StyledMenuItem>

                <StyledMenuItem
                  disabled
                >
                  <BsCalendarCheck style={{ marginRight: '.4rem' }} />
                  PDI
                </StyledMenuItem>

                <StyledMenuItem
                  disabled
                >
                  <FaChalkboardTeacher style={{ marginRight: '.4rem' }} />
                  Imersão cultural
                </StyledMenuItem>

                <StyledMenuItem
                  disabled
                >
                  <GoGraph style={{ marginRight: '.4rem' }} />
                  Indicadores
                </StyledMenuItem>
              </StyledMenuList>
            </Menu>
          )
        }

        {((!GestoresViaCerta() && parseJwt()?.adm === 'False') || !Permissoes.engajamento) && (
          <Menu>
            <StyledMenuButton rightIcon={<FaChevronDown style={{ marginLeft: '-4px' }} size={10}/>}>
              Engajamento
            </StyledMenuButton>
            <StyledMenuList>
              <StyledMenuItem>
                <FaColumns style={{ marginRight: '.4rem' }} />
                Módulo bloqueado
              </StyledMenuItem>

              <StyledMenuItem
                disabled
              >
                <FaColumns style={{ marginRight: '.4rem' }} />
                Dashboard
              </StyledMenuItem>

              <StyledMenuItem
                disabled
              >
                <img src={LogoPec} style={{ marginRight: '.4rem', height: '1rem' }} />
                Pesquisa de engajamento
              </StyledMenuItem>

              <StyledMenuItem
                disabled
              >
                <img src={LogoPulse} style={{ marginRight: '.4rem', height: '1rem' }} />
                Pesquisa Pulse
              </StyledMenuItem>

              <StyledMenuItem
                disabled
              >
                <img src={LogoFO} style={{ marginRight: '.4rem', height: '1rem' }} />
                Radar
              </StyledMenuItem>

              <StyledMenuItem
                disabled
              >
                <FaTachometerAlt style={{ marginRight: '.4rem' }} />
                eNPS
              </StyledMenuItem>

              {Permissoes.usuarioNovo && (
                <StyledMenuItem
                  disabled
                >
                  <FaTachometerAlt style={{ marginRight: '.4rem' }} />
                  eNPS (Cíclico)
                </StyledMenuItem>
              )
              }

              <StyledMenuItem onClick={() => nav('/Tutoriais/Engajamento')}>
                <FaVideo style={{ marginRight: '.4rem' }} />
                Conheça o módulo Engajamento
              </StyledMenuItem>
            </StyledMenuList>
          </Menu>
        )
        }

        {(GestoresViaCerta() || parseJwt()?.adm === 'True') && Permissoes.engajamento && temAlgumaPermissao('Engajamento') && (
          <Menu>
            <StyledMenuButton rightIcon={<FaChevronDown style={{ marginLeft: '-4px' }} size={10}/>}>
              Engajamento
            </StyledMenuButton>
            <StyledMenuList>
              {
                ((GestoresViaCerta() && permitirFuncao('Engajamento', 'dash')) || parseJwt()?.adm === 'True') && (
                  <StyledMenuItem
                    onClick={() => nav('/Engajamento')}
                  >
                    <FaColumns style={{ marginRight: '.4rem' }} />
                    Dashboard
                  </StyledMenuItem>
                )
              }

              {
                ((GestoresViaCerta() && permitirFuncao('Engajamento', 'pec')) || parseJwt()?.adm === 'True') && (
                  <StyledMenuItem
                    onClick={() => nav('/Engajamento/Gestao')}
                  >
                    <img src={LogoPec} style={{ marginRight: '.4rem', height: '1rem' }} />
                    Gestão de pesquisas de engajamento
                  </StyledMenuItem>
                )
              }

              {
                ((GestoresViaCerta() && permitirFuncao('Engajamento', 'pulse')) || parseJwt()?.adm === 'True') && (
                  <StyledMenuItem
                    onClick={() => redirectPage('PesquisaPulse', 'Index')}
                  >
                    <img src={LogoPulse} style={{ marginRight: '.4rem', height: '1rem' }} />
                    Pesquisa Pulse
                  </StyledMenuItem>
                )
              }

              {((GestoresViaCerta() && permitirFuncao('Engajamento', 'feedback')) || parseJwt()?.adm === 'True') && (
                <StyledMenuItem
                  onClick={() => redirectPage('FeedbackOrganizacao', 'Index')}
                >
                  <img src={LogoFO} style={{ marginRight: '.4rem', height: '1rem' }} />
                  Radar
                </StyledMenuItem>
              )}

              {
                ((GestoresViaCerta() && permitirFuncao('Jornada', 'enps')) || parseJwt()?.adm === 'True') && (
                  <StyledMenuItem
                    onClick={() => nav(Permissoes.usuarioNovo ? '/Jornada/eNps' : '/Engajamento/eNPS')}
                  >
                    <FaTachometerAlt style={{ marginRight: '.4rem' }} />
                    eNPS
                  </StyledMenuItem>
                )
              }

              {Permissoes.usuarioNovo && (GestoresViaCerta() && permitirFuncao('Engajamento', 'enps')) && (
                <StyledMenuItem
                  onClick={() => nav('/Engajamento/eNPS')}
                >
                  <FaTachometerAlt style={{ marginRight: '.4rem' }} />
                  eNPS (Cíclico)
                </StyledMenuItem>
              )
              }

              <StyledMenuItem onClick={() => nav('/Tutoriais/Engajamento')}>
                <FaVideo style={{ marginRight: '.4rem' }} />
                Conheça o módulo Engajamento
              </StyledMenuItem>

            </StyledMenuList>
          </Menu>
        )}

        {/* {(parseJwt().eid === 'acbf6a22-154e-480d-a465-61b990faa8bd' || Permissoes.usuarioNovo === true) && Permissoes.pesquisa360 &&
          <Menu>
            <StyledMenuButton rightIcon={<FaChevronDown style={{ marginLeft: '-4px' }} size={10}/>}>
              Pesquisa 360
            </StyledMenuButton>
            <StyledMenuList>

              <StyledMenuItem
                onClick={() => nav('/Desempenho/AnaliseDesempenho/Indicativa/Criar')}
              >
                <TbHandClick style={{ marginRight: '.4rem' }} />
                Criar pesquisa indicativa
              </StyledMenuItem>

              <StyledMenuItem
                onClick={() => nav('/Desempenho/AnaliseDesempenho/Quantitativa/Criar')}
              >
                <FaListOl style={{ marginRight: '.4rem' }} />
                Criar pesquisa tradicional
              </StyledMenuItem>

              <StyledMenuItem
                onClick={() => nav('/Desempenho/AnaliseDesempenho/Gestao')}
              >
                <FaCopy style={{ marginRight: '.4rem' }} />
                Gestão de pesquisas
              </StyledMenuItem>

            </StyledMenuList>
          </Menu>
        }

        {
          (Permissoes.usuarioNovo === true) && !Permissoes.pesquisa360 && (
            <Menu>
              <StyledMenuButton rightIcon={<FaChevronDown style={{ marginLeft: '-4px' }} size={10}/>}>
                Pesquisa 360
              </StyledMenuButton>
              <StyledMenuList>
                <StyledMenuItem>
                  <FaColumns style={{ marginRight: '.4rem' }} />
                  Módulo bloqueado
                </StyledMenuItem>

                <StyledMenuItem
                  disabled
                >
                  <TbHandClick style={{ marginRight: '.4rem' }} />
                  Criar pesquisa indicativa
                </StyledMenuItem>

                <StyledMenuItem
                  disabled
                >
                  <FaListOl style={{ marginRight: '.4rem' }} />
                  Criar pesquisa tradicional
                </StyledMenuItem>

                <StyledMenuItem
                  disabled
                >
                  <FaCopy style={{ marginRight: '.4rem' }} />
                  Gestão de pesquisas
                </StyledMenuItem>
              </StyledMenuList>
            </Menu>
          )
        } */}

        {
          (Permissoes.cargosESalarios && (acessoCargos || acessoSalarios || acessoTrilhas || gerenciaTrilhaCarreira)) && (
            <Menu>
              <StyledMenuButton rightIcon={<FaChevronDown style={{ marginLeft: '-4px' }} size={10}/>}
              >Cargos e Salários
              </StyledMenuButton>
              <StyledMenuList>
                {acessoCargos && (
                  <StyledMenuItem
                    onClick={() => nav('/Descritivo/Cargos')}
                  >
                    <FaBriefcase style={{ marginRight: '.4rem' }} />
                    Cargos
                  </StyledMenuItem>
                )}
                {acessoSalarios && (
                  <StyledMenuItem
                    onClick={() => nav('/Descritivo/Salarios')}
                  >
                    <FaMoneyBill style={{ marginRight: '.4rem' }} />
                    Salários
                  </StyledMenuItem>
                )}
                {acessoCargosESalarios && (
                  <StyledMenuItem
                    onClick={() => nav('/Descritivo/Criterios')}
                  >
                    <FaStream style={{ marginRight: '.4rem' }} />
                    Critérios
                  </StyledMenuItem>
                )}
                {(acessoTrilhas || gerenciaTrilhaCarreira) && (
                  <StyledMenuItem
                    onClick={() => nav('/Descritivo/Trilhas')}
                  >
                    <FaBell style={{ marginRight: '.4rem' }} />
                    Trilhas de carreira
                  </StyledMenuItem>
                )}
                {acessoCargosESalarios && (
                  <StyledMenuItem onClick={() => nav('/Descritivo/PainelAssinaturas')}>
                    <FaFileSignature style={{ marginRight: '.4rem' }} />
                    Painel de assinaturas
                  </StyledMenuItem>
                )}
                {acessoCargosESalarios && (
                  <StyledMenuItem onClick={() => nav('/Tutoriais/Cargos e Salários')}>
                    <FaVideo style={{ marginRight: '.4rem' }} />
                    Conheça o módulo Cargos e Salários
                  </StyledMenuItem>
                )}
              </StyledMenuList>
            </Menu>
          )
        }
        {
          (!Permissoes.cargosESalarios && parseJwt().adm === 'True') && (
            <Menu>
              <StyledMenuButton rightIcon={<FaChevronDown style={{ marginLeft: '-4px' }} size={10}/>}>
                Cargos e Salários
              </StyledMenuButton>
              <StyledMenuList>
                <StyledMenuItem>
                  <FaColumns style={{ marginRight: '.4rem' }} />
                  Módulo bloqueado
                </StyledMenuItem>

                <StyledMenuItem
                  disabled
                >
                  <FaBriefcase style={{ marginRight: '.4rem' }} />
                  Cargos
                </StyledMenuItem>

                <StyledMenuItem
                  disabled
                >
                  <FaMoneyBill style={{ marginRight: '.4rem' }} />
                  Salários
                </StyledMenuItem>

                <StyledMenuItem
                  disabled
                >
                  <FaStream style={{ marginRight: '.4rem' }} />
                  Critérios
                </StyledMenuItem>

                <StyledMenuItem
                  disabled
                >
                  <FaBell style={{ marginRight: '.4rem' }} />
                  Trilhas de carreira
                </StyledMenuItem>

                <StyledMenuItem onClick={() => nav('/Tutoriais/Cargos e Salários')}>
                  <FaVideo style={{ marginRight: '.4rem' }} />
                  Conheça o módulo Cargos e Salários
                </StyledMenuItem>
              </StyledMenuList>
            </Menu>
          )
        }

        {
          (Permissoes.organograma && temAlgumaPermissao('Organograma')) && (
            <Menu>
              <StyledMenuButton rightIcon={<FaChevronDown style={{ marginLeft: '-4px' }} size={10}/>}
              >Organograma
              </StyledMenuButton>
              <StyledMenuList>
                {
                  (parseJwt().adm === 'True' || permitirFuncao('Organograma', 'visao-geral')) && (
                    <StyledMenuItem
                      onClick={() => nav('/Organograma/Dashboard')}
                    >
                      <FaSitemap style={{ marginRight: '.4rem' }} />
                      Visão geral
                    </StyledMenuItem>
                  )
                }

                {
                  (parseJwt().adm === 'True' || permitirFuncao('Organograma', 'areas')) && (
                    <StyledMenuItem
                      onClick={() => nav('/Organograma/Departamentos')}
                    >
                      <FaIdCard style={{ marginRight: '.4rem' }} />
                      Áreas
                    </StyledMenuItem>
                  )
                }

                {
                  (parseJwt().adm === 'True' || permitirFuncao('Organograma', 'funcoes')) && (
                    <StyledMenuItem
                      onClick={() => nav('/Organograma/Cargos')}
                    >
                      <FaBriefcase style={{ marginRight: '.4rem' }} />
                      Cargos
                    </StyledMenuItem>
                  )
                }

                {
                  (parseJwt().adm === 'True' || permitirFuncao('Organograma', 'squads')) && (
                    <StyledMenuItem
                      onClick={() => nav('/Organograma/Squads')}
                    >
                      <FaPeopleArrows style={{ marginRight: '.4rem' }} />
                      Squads
                    </StyledMenuItem>
                  )
                }

                {
                  (parseJwt().adm === 'True' || permitirFuncao('Organograma', 'colaboradores')) && (
                    <StyledMenuItem
                      onClick={() => nav('/Organograma/Colaboradores')}
                    >
                      <FaUsersCog style={{ marginRight: '.4rem' }} />
                      Colaboradores
                    </StyledMenuItem>
                  )
                }
              </StyledMenuList>
            </Menu>
          )
        }

        {
          (!Permissoes.organograma) && (
            <Menu>
              <StyledMenuButton rightIcon={<FaChevronDown style={{ marginLeft: '-4px' }} size={10}/>}>
                Organograma
              </StyledMenuButton>
              <StyledMenuList>
                <StyledMenuItem>
                  <FaColumns style={{ marginRight: '.4rem' }} />
                  Módulo bloqueado
                </StyledMenuItem>

                <StyledMenuItem
                  disabled
                >
                  <FaSitemap style={{ marginRight: '.4rem' }} />
                  Visão geral
                </StyledMenuItem>

                <StyledMenuItem
                  disabled
                >
                  <FaIdCard style={{ marginRight: '.4rem' }} />
                  Áreas
                </StyledMenuItem>

                <StyledMenuItem
                  disabled
                >
                  <FaBriefcase style={{ marginRight: '.4rem' }} />
                  Cargos
                </StyledMenuItem>

                <StyledMenuItem
                  disabled
                >
                  <FaUsersCog style={{ marginRight: '.4rem' }} />
                  Colaboradores
                </StyledMenuItem>
              </StyledMenuList>
            </Menu>
          )
        }

        {/* {(parseJwt().eid !== 'acbf6a22-154e-480d-a465-61b990faa8bd' && parseJwt().eid !== 'c5d7423c-5fbc-4917-a667-c2a2ec9693d7') && */}

        {parseJwt().eid === 'acbf6a22-154e-480d-a465-61b990faa8bd' && (
          <Menu>
            <StyledMenuButton onClick={() => nav('/CentralComando')}>
              Central de comando
            </StyledMenuButton>
          </Menu>
        )}

        {parseJwt().eid === 'acbf6a22-154e-480d-a465-61b990faa8bd' && (
          <Menu>
              <StyledMenuButton rightIcon={<FaChevronDown style={{ marginLeft: '-4px' }} size={10}/>}
              >Arquitetura Humana
              </StyledMenuButton>

              <StyledMenuList>
                <StyledMenuItem
                      onClick={() => nav('/ArquiteturaHumana')}
                    >
                      <FaUsersCog style={{ marginRight: '.4rem' }} />
                      Nova Arquitetura Humana
                    </StyledMenuItem>

              </StyledMenuList>
            </Menu>

        )}
      </Flex>

      <FlexIcon>
        {usuarioAh && ListaEmpresas.length > 0 && (
          <Flex
            alignItems={'center'}
            gap={'.5rem'}
            px={'.5rem'}
            py={'.25rem'}
            borderRadius={'.25rem'}
            cursor={'pointer'}
            transition={'all 0.2s'}
            maxW={'12rem'}
            color={'white'}
            _hover={{ bg: 'var(--Rosa)' }}
            onClick={() => setModalEmpresasOpen(true)}
          >
            {empresaSelecionada
              ? (
                <>
                  <img
                    src={empresaSelecionada.logo}
                    style={{ height: '1.5rem', width: '1.5rem', borderRadius: '.25rem', objectFit: 'contain', flexShrink: 0 }}
                  />
                  <span style={{ fontSize: '.8rem', fontWeight: 600, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {empresaSelecionada.nome}
                  </span>
                </>
                )
              : (
                <>
                  <FaExchangeAlt style={{ flexShrink: 0 }} />
                  <span style={{ fontSize: '.8rem', fontWeight: 600, whiteSpace: 'nowrap' }}>
                    Trocar empresa
                  </span>
                </>
                )}
          </Flex>
        )}
        <Menu>
          <MenuButton
            px={0}
            _hover={{ bg: 'none' }}
            bg={'none'}
            as={Button}
            rightIcon={<MdMenu size={'1.5rem'} />}
            _focus={{ bg: 'none' }}
            _active={{ bg: 'none' }}
          ></MenuButton>
          <StyledMenuList>

            {modoFree() && (<StyledMenuItem

            >
              <FaBriefcase style={{ marginRight: '.4rem' }} />
              <Badge colorScheme='red'>Modo FREE </Badge>
            </StyledMenuItem>)}
            {
              (parseJwt().adm === 'True') && (
                <StyledMenuItem
                  onClick={() => nav('/Usuario/Permissoes')}
                >
                  <FaHome style={{ marginRight: '.4rem' }} />
                  Gerenciar permissões
                </StyledMenuItem>
              )
            }

            {
              (parseJwt().adm === 'Super') && (
                <StyledMenuItem
                  onClick={() => nav('/Usuario/PermissoesIndividuais')}
                >
                  <FaHome style={{ marginRight: '.4rem' }} />
                  Permissões individuais
                </StyledMenuItem>
              )
            }

            {
              (parseJwt().adm === 'True') && (
                <StyledMenuItem
                  onClick={() => nav('/Usuario/Empresa')}
                >
                  <FaCog style={{ marginRight: '.4rem' }} />
                  Configuração da empresa
                </StyledMenuItem>
              )
            }

            {
              AutorizarRelatorioClientes() && (
                <StyledMenuItem
                  onClick={BaixarRelatorioClientes}
                >
                  <FaUsers style={{ marginRight: '.4rem' }} />
                  Baixar relatório clientes
                </StyledMenuItem>
              )
            }

            {
              (parseJwt().adm === 'True') && (
                <StyledMenuItem
                  onClick={() => nav('/Rh/GestaoAgendamentos')}
                >
                <FaPaperPlane style={{ marginRight: '.4rem' }} />
                Gestão de agendamentos
              </StyledMenuItem>
              )
            }

            <StyledMenuItem
              onClick={() => nav('Usuario/AlterarSenha')}
            >
              <MdPassword style={{ marginRight: '.4rem' }} />
              Alterar senha
            </StyledMenuItem>

            <StyledMenuItem
              onClick={() => nav('/Usuario/PerguntasFrequentes')}
            >
              <FaQuestionCircle style={{ marginRight: '.4rem' }} />
              Perguntas frequentes
            </StyledMenuItem>

            {parseJwt().adm === 'True' && (
              <StyledMenuItem
                onClick={() => nav('/Usuario/DocumentosApoio')}
              >
                <FaBook style={{ marginRight: '.4rem' }} />
                Ajuda
              </StyledMenuItem>
            )}

            <StyledMenuItem
              onClick={() => nav('/Usuario/CanalDenuncia')}
            >
              <FaBullhorn style={{ marginRight: '.4rem' }} />
              Ouvidoria
            </StyledMenuItem>

            <StyledMenuItem
              onClick={() => nav('/Usuario/ChamadoRh')}
            >
              <FaHeadset style={{ marginRight: '.4rem' }} />
              Chamado com RH
            </StyledMenuItem>

            {permissaoLog.permitido && (
              <StyledMenuItem
                onClick={() => nav('/Auditoria')}
              >
                <FaHome style={{ marginRight: '.4rem' }} />
                Log de auditoria
              </StyledMenuItem>
            )}

            <StyledMenuItem
              onClick={() => { logOut(true); nav('/') }}
            >
              <MdLogout style={{ marginRight: '.4rem' }} />
              Sair
            </StyledMenuItem>
          </StyledMenuList>
        </Menu>
      </FlexIcon>
    </Container>
    {usuarioAh && (
      <ModalSelecaoEmpresa
        isOpen={modalEmpresasOpen}
        onClose={() => setModalEmpresasOpen(false)}
        empresas={ListaEmpresas}
        onSelecionar={selecionarEmpresa}
        onRetornar={retornarParaAh}
      />
    )}
    {modoFree() && (
      <Alert status='warning'>
        <AlertIcon />
        <Link href='mailto:comercial@arquiteturahumana.com.br'>Sua empresa utiliza o plano gratuito do SAH limitado a 5 colaboradores, para contratar os planos com funcionalidades completas entre em contato com seu consultor de conta</Link>.
      </Alert>)}
  </>
  )
}
